(() => {
  'use strict';

  angular
  .module('mgpCorregedoriaApp.validacao')
  .directive('nodeListVisualizacaoAnuario',NodeListVisualizacaoAnuario);

  function NodeListVisualizacaoAnuario($compile,$templateCache){

    var directive = {

      restrict: 'E',
      terminal: true,
      scope: {
        nodes: '=ngModel',
        add: '&',
        exportar: '&'
      },
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, element) {
      if (angular.isArray(scope.nodes)) {
        element.append($templateCache.get('sub-registros-visualizacao-anuario.html'));
      }
      $compile(element.contents())(scope.$new());
    }
  }
})();
